<template>
    <div class="payment-type-item-wrapper with-pencil" v-if="account.balance >= 1">
        <div :class="{selected: account.selected}" @click="selectPaymentAccount"
             class="payment-type-item">
            <div class="content">
                <div class="name">{{account.type.name}}:</div>
                <div class="discount-flat">{{account.balance}} {{setting.currency}}</div>
                <div class="discount-flat" v-if="account.discount.value && account.selected">(будет списано
                    {{account.discount.value}} {{setting.currency}})
                </div>
            </div>
        </div>
        <div @click="clickPencil" class="change-bonus" v-if="!account.picker">
            <svg height="528.899px" id="Capa_1" style="enable-background:new 0 0 528.899 528.899;" version="1.1"
                 viewBox="0 0 528.899 528.899" width="528.899px"
                 x="0px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 y="0px">
              <g>
                <path d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981
                  c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611
                  C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069
                  L27.473,390.597L0.3,512.69z"/>
              </g>
          </svg>
        </div>
        <div class="bonus-picker bonus-picker_shown" v-if="account.picker">
            <vue-slider
                    :interval="1"
                    :lazy="true"
                    :max="account.discount.max.all"
                    :min="1"
                    :tooltip="'always'"
                    :tooltip-placement="'bottom'"
                    @change="handleChange"
                    v-model="sliderValue"
            ></vue-slider>
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  import VueSlider from 'vue-slider-component';
  import { types } from '../types';

  export default {
    name: 'AccountButton',
    props: ['accountId'],
    components: {
      VueSlider,
    },
    computed: {
      sliderValue: {
        get: function() {
          return this.account.discount.value;
        },
        set: function() {
        },
      },
      account() {
        return this.$store.state.customer.accounts[this.accountId];
      },
      ...mapState(['user', 'cart', 'customer', 'setting']),
      // ...mapGetters(['availableDiscounts','maxAvailableDiscountToAccount']),
    },
    methods: {
      handleChange(value) {
        const { account } = this;
        const accountId = account.id;

        this.$store.commit(types.UNPICKED_CUSTOMER_ACCOUNTS);
        const maxDiscount = this.$store.getters.maxAvailableDiscountToAccount(accountId);

        let tickets = Math.ceil(value / 2);
        if (tickets > maxDiscount.tickets) {
          tickets = maxDiscount.tickets;
        }

        let bar = value - tickets;
        if (bar > maxDiscount.bar) {
          tickets += bar;
          bar = maxDiscount.bar;
        }

        this.$store.commit(types.SET_CUSTOMER_ACCOUNT, {
          accountId,
          data: {
            changed: true,
            discount: {
              value,
              bar,
              tickets,
            },
          },
        });

        this.$store.commit(types.CALCULATE_CART);
      },
      clickPencil() {
        const { account } = this;
        const accountId = account.id;

        this.$store.commit(types.UNPICKED_CUSTOMER_ACCOUNTS);
        this.$store.commit(types.UNSELECT_CUSTOMER_ACCOUNTS);
        let data = {
          picker: true,
          selected: true,
        };

        if (!account.changed) {
          const maxDiscount = this.$store.getters.maxAvailableDiscountToAccount(accountId);

          data.discount = {
            max: maxDiscount,
            bar: maxDiscount.bar,
            tickets: maxDiscount.tickets,
            value: maxDiscount.all,
          };
        }

        this.$store.commit(types.SET_CUSTOMER_ACCOUNT, {
          accountId,
          data,
        });

        this.$store.commit(types.CALCULATE_CART);
      },
      selectPaymentAccount() {
        const account = this.account;
        const { id: accountId } = account;
        const selected = account.selected;

        this.$store.commit(types.UNSELECT_CUSTOMER_ACCOUNTS);
        this.$store.commit(types.UNPICKED_CUSTOMER_ACCOUNTS);
        this.user.paymentType = 'online'

        if (!selected) {
          let data = {
            selected: true,
            changed: true,
          };

          if (!account.changed) {
            const maxDiscount = this.$store.getters.maxAvailableDiscountToAccount(accountId);
            data.discount = {
              max: maxDiscount,
              bar: maxDiscount.bar,
              tickets: maxDiscount.tickets,
              value: maxDiscount.all,
            };
          }

          this.$store.commit(types.SET_CUSTOMER_ACCOUNT, { accountId, data });
        }

        this.$store.commit(types.CALCULATE_CART);
      },
    },
  };
</script>

<style scoped>

</style>
